import { render, staticRenderFns } from "./OptionInto.vue?vue&type=template&id=39979d30&scoped=true&"
import script from "./OptionInto.vue?vue&type=script&lang=js&"
export * from "./OptionInto.vue?vue&type=script&lang=js&"
import style0 from "./OptionInto.vue?vue&type=style&index=0&id=39979d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39979d30",
  null
  
)

component.options.__file = "OptionInto.vue"
export default component.exports